import { useState } from 'react';
// mantine
import { Badge, Button, Paper } from '@mantine/core';
// utils
import { cn } from '@/utils';

interface SubscriptionCardProps {
    id: string;
    title: string;
    price: string;
    phoneSessions: string;
    textSessions: string;
    isActive: boolean;
    isDisabled: boolean;
    withTrial: boolean;
    onSubscribe: (productKey: string) => Promise<unknown>;
}

const SubscriptionCard = ({
    id,
    title,
    price,
    phoneSessions,
    textSessions,
    isActive,
    isDisabled,
    withTrial,
    onSubscribe
}: SubscriptionCardProps) => {
    const [isLoading, setIsLoading] = useState(false);
    const handleSubscribe = async () => {
        setIsLoading(true);
        try {
            await onSubscribe(id);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <Paper
            className={cn('flex flex-col gap-4 bg-gray-1 p-5 font-normal', {
                'bg-white border border-gray-2': isActive
            })}
            shadow="xs"
        >
            <div className="flex items-center justify-between gap-2">
                <div className="font-bold">{title}</div>
                {isActive ? <Badge color="green">Active</Badge> : undefined}
            </div>
            <div className="text-2xl font-bold">
                {title === 'Enterprise' ? (
                    'Custom'
                ) : (
                    <>
                        {price}{' '}
                        <span className="text-sm font-normal"> / mo</span>
                    </>
                )}
            </div>

            {withTrial ? (
                <div className="text-green-8 text-md font-semibold text-balance">
                    14-day FREE trial.
                </div>
            ) : undefined}
            <div className="text-xs">
                Units per month:
                <div className="flex justify-between mt-2">
                    Phone <span>{phoneSessions}</span>
                </div>
                <div className="opacity-50 text-center leading-none">or</div>
                <div className="flex justify-between">
                    Text <span>{textSessions}</span>
                </div>
            </div>
            <Button
                disabled={isDisabled}
                loading={isLoading}
                size="xs"
                onClick={handleSubscribe}
            >
                {withTrial ? 'Try it for Free' : 'Change Subscription'}
            </Button>
        </Paper>
    );
};

export default SubscriptionCard;
